import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserSummaryComponent } from './user-summary';
import { UserDetailComponent } from './user-detail';
import { UserAddComponent } from './user-add';
import { UserEditComponent } from './user-edit';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'User'
    },
    children: [
      {
        path: 'summary',
        component: UserSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: UserDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: UserEditComponent,
        data: { title: 'Edit' }
      },
      {
        path: 'add',
        component: UserAddComponent,
        data: { title: 'Add' }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-routing.module.ts